import 'reflect-metadata'
import '@/client/assets/scss/app.scss'
import '@mdi/font/css/materialdesignicons.css'
import ElementUI, { Message, Notification } from 'element-ui'
import ElementLocale from 'element-ui/lib/locale'
import ElementJaLocale from 'element-ui/lib/locale/lang/ja'
import moment from 'moment-timezone'
import { PiniaVuePlugin, setActivePinia } from 'pinia'
import Vue from 'vue'
import VueTimeago from 'vue-timeago'
import Vuelidate from 'vuelidate'

import App from '@/client/App.vue'
import router from '@/client/router'
import { pinia } from '@/client/store/pinia'
import { useSystemStore } from '@/client/store/useSystemStore'

moment.locale('ja')

ElementLocale.use(ElementJaLocale)

Vue.use(ElementUI)

Vue.use(PiniaVuePlugin)

Vue.prototype.$notify = Notification

Vue.use(Vuelidate)
Vue.use(VueTimeago, {
  name: 'timeago',
  locale: 'ja',
  locales: {
    ja: require('vue-timeago/locales/ja-JP.json')
  }
})

Vue.prototype.$message = (options: any) => {
  Message(options)
}

// 言語をストアに保存する
setActivePinia(pinia)
useSystemStore().setLanguage('ja')

// エラーハンドリング
Vue.config.errorHandler = err => {
  console.error(err.stack)
}

window.addEventListener('unhandledrejection', e => {
  console.error('Unhandled Rejection at:', e)
})

Vue.config.productionTip = false

const app = new Vue({ router, pinia, render: h => h(App) })

app.$mount('#app-root')
